<template>
  <div v-if="tenantDesignConfig.general.hasFeedback">
    <user-review-modal
      :review="review"
      @submitReview="submitReview"
      :userProductRate="userProductRate"
    />
    <template v-if="productHasComment">
      <h5>{{$t('UserReview.Comments')}}
      </h5>
      
    <section class="d-flex flex-wrap flex-column justify-content-between">
      <div class="row small-p">
      <user-review-card v-for="review in ReviewList" :key="review.nickname" :review="review" />
      </div>
    </section>
    
    </template>
    <section v-else>
      <h5 class="text-center">
        {{$t('UserReview.ProductHasNoComment')}}
      </h5>
    </section>
     <user-review-header
      :total-review="totalReview"
      @showUserReviewModal="showUserReview"
      @submitRate="submitRate"
      :userProductRate="userProductRate"
    />
    <!-- <section class="d-flex justify-content-center mt-4">
      <b-link href="#">
        {{ $t('UserReview.MoreComments') }}
      </b-link>
    </section> -->
    <b-modal id="modal-login" hide-footer centered body-class="d-flex flex-column justify-content-center">
    <template>
      <h5>
        {{$t('login.loginWarning')}}
      </h5>
      <!-- <b-nav-item
          v-if="!isUserLoggedIn && tenantLoginType === 'organic'"
          class="ml-auto p-0 bt-loginregister"
          
        > -->
        <div class="d-flex align-self-end">
           <b-button variant="outline-danger" class="mx-2" @click="$bvModal.hide('modal-login')">
          {{$t('UserReview.Cancel')}}
        </b-button>
        <b-button variant="success" @click="login">
          {{$t('header.loginRegister')}}
        </b-button>
        </div>
        <!-- </b-nav-item> -->
    </template>
  </b-modal>
  </div>
</template>

<script>
import UserReviewCard from '@/components/UserReviewCard.vue'
import UserReviewHeader from '@/components/UserReviewHeader.vue'
import UserReviewModal from '@/components/UserReviewModal.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserReview',
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    UserReviewHeader,
    UserReviewCard,
    UserReviewModal
  },
  computed: {
    ...mapGetters({
      userReviewModalVisibility: 'userReview/userReviewModalVisibility',
      productComments: 'userReview/productComments',
      isUserLoggedIn: 'auth/isUserAuthenticated',
      tenantDesignConfig: 'tenantDesign/config',
      userProductRate: 'userReview/userProductRate',
    }),
    productHasComment(){
      return this.ReviewList.length > 0 ? true : false
    }
  },
  data () {
    return {
      // showUserReviewModal: false,
      review: {
        description: '',
        rate: 0
      },
      totalReview: {
        star: 4,
        rate: 4.6,
        numberOfReviews: 42,
        fiveStarPercent: 32,
        fourStarPercent: 46,
        threeStarPercent: 94,
        twoStarPercent: 35,
        oneStarPercent: 12
      },
      ReviewList: []
    }
  },
  methods: {
    ...mapActions({
      showUserReviewModal: 'userReview/showUserReviewModal',
      rateProduct:'userReview/rateProduct',
      addComment: 'userReview/addComment',
      loadProductComments: 'userReview/loadProductComments',
      loadUserProductRate: 'userReview/getUserProductRate',
      getProductRate: 'userReview/getProductRate'
    }),
    showUserReview (rate) {
      if(!this.isUserLoggedIn)
      {
        this.$bvModal.show('modal-login')
      }else
      {
      this.showUserReviewModal()
      this.review.rate = rate
      }
    },

    submitReview (review) {
        let reviewPayload = {
          productId : this.product.id,
          commentText : review.description,
          replayToId :''
        }
        let payload = {
        productId: this.product.id,
        rate: review.rate
        }
        if(review.rate === 0){
          this.$bvToast.toast(this.$t('UserReview.CommitYourRate'), {
                title: this.$t('UserProfile.Subscription.BuySubscriptionFactor.warning'),
                autoHideDelay: 3000,
                appendToast: true,
                variant: 'warning',
                solid: true
          })
        }
        else{
        this.rateProduct(payload).then((response)=>{
          if(response.body.success===true)
          {
             if(reviewPayload.commentText.trim() === '')
              {
                return false
              }
              this.addComment(reviewPayload).then((response)=>{
                 this.$bvToast.toast(this.$t('UserReview.ReviewSubmitted'), {
                title: this.$t('UserReview.SuccessfullTitle'),
                autoHideDelay: 3000,
                appendToast: true,
                variant: 'success',
                solid: true
              })
              this.$bvModal.hide('review-modal')
              this.getProductRate(this.product.id)
          })
        }
      })
      }
    },
    submitRate(rate)
    {
      if(!this.isUserLoggedIn)
      {
        this.$bvModal.show('modal-login')
      }
      else{
      let payload = {
        productId: this.product.id,
        rate: rate
      }
      this.rateProduct(payload).then((response)=>{
        if(response.body.success===true)
        {
            this.$bvToast.toast(this.$t('UserReview.RateSubmitted'), {
                    title: this.$t('UserReview.SuccessfullTitle'),
                    autoHideDelay: 3000,
                    appendToast: true,
                    variant: 'success',
                    solid: true
                  })
        }
      }) 
      }
    },
    login()
    {
      window.localStorage.setItem('lastProductPageId', this.product.id);
      this.$router.push({ name: 'login' })
    }
  },
  created()
  {
      this.loadProductComments(this.product.id).then((response)=>{
        this.ReviewList = this.productComments
      })
      if(this.isUserLoggedIn){
          this.loadUserProductRate(this.product.id)
      }
  }
}
</script>
